var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-div"},[_c('div',{staticClass:"table-title"},[_vm._v("家庭成员信息")]),_c('div',{staticClass:"table-container"},[_c('Table',{attrs:{"border":"","columns":_vm.tableColumns,"data":_vm.familyData,"height":600}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }